<template>
  <el-upload style="display: inline-block;" :headers="header" :action="uploadUrl" :on-success="handleSuccess"
    :on-error="handleError" :before-upload="onBeforeUpload" :show-file-list="false" :data="subData">
    <el-button :style="w ? 'width: ' + w : ''" type="primary" :size="size">{{ text }}</el-button>
  </el-upload>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    uploadUrl: {
      type: String,
      default: "/api" + api.uploadPhotoUrl,
    },
    type: {
      type: String,
      default: undefined,
    },
    //文件大小，默认50Mb
    fileSize: {
      type: Number,
      default: 25,
    },
    fileType: {
      type: Array,
      default: () => [],
    },
    subData: {
      type: Object,
      default: () => { },
    },
    text: {
      type: String,
      default: "导 入",
    },
    size: {
      type: String,
      default: "mini"
    },
    //按钮宽度
    w: {
      type: String,
      default: "150px",
    },
    //上传之前，返回true进行上传，返回false不进行上传
    beforeUpload: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    //上传前回调
    onBeforeUpload(file) {
      if (this.fileType.length != 0) {
        let pos = file.name.lastIndexOf(".");
        let extension = file.name.substring(pos + 1, file.name.length);
        console.log("file.type", extension, this.fileType);
        if (this.fileType.indexOf(extension) == -1) {
          this.$message.warning("请上传正确的文件格式");
          return false;
        }
      }

      let promise = Promise.resolve();
      if (this.beforeUpload) {
        let bu = this.beforeUpload();
        console.log("beforeUpload", bu);
        if (bu == false) {
          return false;
        } else if (bu instanceof Promise) {
          promise = bu;
        }
      }
      promise.then(() => {
        var fileSize = file.size / 1024 / 1024 < this.fileSize;
        console.log("fileSize", fileSize);
        this.isLoading = this.$loading({
          lock: true,
          text: "导入中...",
          spinner: "el-icon-loading",
          customClass: "my_loading",
          background: "rgba(0, 0, 0, 0.3)",
        });
        if (!fileSize) {
          this.$message.warning(`文件大小不能超过${this.fileSize}Mb`);
          this.isLoading.close();
          return false;
        }
      });
    },
    //上传成功回调
    handleSuccess(res, file) {
      console.log("success", res);
      this.isLoading.close();
      this.$emit("on-uploaded", res);

      if (res.code == 0) {
        this.$message.success(res.msg);
      }
    },
    handleError(err, file, fileList) {
      this.isLoading.close();
      this.$message.error(err.errorMessage);
    }
  },
};
</script>

<style lang="scss">
.upload-item {
  height: 40px;
  line-height: 40px;
}

.my_loading {
  i {
    font-size: 38px;
    color: #3a3a3a;
  }

  .el-loading-text {
    font-size: 22px;
    display: inline;
    margin-left: 10px;
    vertical-align: super;
    color: #3a3a3a;
  }
}
</style>